import { ModalProps } from "antd/lib/modal/Modal";
import { Alert, Button, message, Modal, Table } from "antd";
import styles from "./index.module.scss";
import React from "react";
import { ColumnProps } from "antd/lib/table/interface";
import useSelection from "../../utils/v2/useSelection";
import useRequest from "../../utils/useRequest";
import {
    deleteDeleteFile,
    DeleteItemProps,
    getDeleteFileList
} from "../../service/recycleBin";
import FileItem from "../../components/FileItem";
import moment from "moment";
import useRequestFn from "../../utils/useRequestFn";
import { errorMessage } from "../../service/service";
import { ResultMessage } from "../../components/ResultMessage";
import DeleteConfirm from "../../components/DeleteConfirm";

interface DataModalInstance {
    setPayload: (payload: any) => void;
}

interface DataModalProps extends ModalProps {
    onCancel?: () => void;
}

const RecycleBinModal = React.forwardRef<DataModalInstance, DataModalProps>(
    ({ onOk, onCancel, ...props }, ref) => {
        const [tableData, { loading: getLoading }, reload] =
            useRequest(getDeleteFileList);

        const [deleteAction, { loading: deleteLoading }] =
            useRequestFn(deleteDeleteFile);

        async function deleteData(ids: string) {
            try {
                await deleteAction({ id: ids });
                await reload();
                message.success("删除成功");
            } catch (e) {
                ResultMessage.error(errorMessage(e));
            }
        }

        const columns: ColumnProps<DeleteItemProps>[] = [
            {
                title: "名称",
                dataIndex: "fileName",
                render: (text: string, record) => {
                    return <FileItem fileType={record.fileType} text={text} />;
                }
            },
            {
                title: "大小",
                dataIndex: "fileSize",
                width: 200
            },
            {
                title: "删除时间",
                dataIndex: "updateTime",
                width: 180,
                render: (text: string) =>
                    moment(text).format("YYYY-MM-DD hh:mm:ss")
            },
            {
                title: "有效时间",
                dataIndex: "expireTime",
                width: 100,
                align: "center"
            },
            {
                title: "操作",
                width: 150,
                dataIndex: "id",
                align: "center",
                render: (id: string, record) => {
                    return (
                        <div className={styles.toolRow}>
                            <a
                                className={styles.a}
                                href={`${record.viewUrl}?attname=${record.fileName}`}
                                target="_blank">
                                下载
                            </a>
                            <DeleteConfirm
                                title="确定删除吗？"
                                content="在回收站删除的文件将不可恢复。"
                                onSuccess={() => deleteData(id)}>
                                <Button type="link" size="small">
                                    删除
                                </Button>
                            </DeleteConfirm>
                        </div>
                    );
                }
            }
        ];

        const rowSelection = useSelection();

        function deleteMany() {
            const ids = rowSelection.selected.join(",");
            deleteData(ids);
        }

        function deleteAll() {
            const ids = tableData?.map(i => i.id).join(",");
            if (ids) {
                deleteData(ids);
            }
        }

        return (
            <Modal
                {...props}
                className={styles.root}
                onCancel={onCancel}
                footer={false}
                maskClosable={false}
                title="课件回收站">
                <Alert
                    style={{ marginBottom: 15 }}
                    message="温馨提示：回收站里存放着被删除的除直播回放的课件，自删除日计起， 180 天内的被删除的课件可查询可下载。"
                    type="info"
                />
                <div className={styles.tools}>
                    <DeleteConfirm
                        title="确定清空回收站吗？"
                        content="删除后课件将不可找回。"
                        onSuccess={deleteAll}>
                        <Button type="danger">清空回收站</Button>
                    </DeleteConfirm>
                    <DeleteConfirm
                        title="确定删除吗？"
                        content="删除后课件将不可找回。"
                        onSuccess={deleteMany}>
                        <Button
                            disabled={rowSelection.selected.length === 0}
                            style={{ marginLeft: 15 }}>
                            批量删除
                            {rowSelection.selected.length > 0 && (
                                <span>({rowSelection.selected.length})</span>
                            )}
                        </Button>
                    </DeleteConfirm>
                </div>
                <Table
                    loading={getLoading || deleteLoading}
                    rowKey="id"
                    rowSelection={rowSelection}
                    dataSource={tableData || []}
                    columns={columns}
                    scroll={{ y: "50vh" }}
                />
            </Modal>
        );
    }
);

RecycleBinModal.displayName = "RecycleBinModal";
export default RecycleBinModal;
